@if (to?.collapsibleFieldGroups) {
  <fieldset
    class="op-fieldset op-fieldset_collapsible"
    [ngClass]="{'op-fieldset_collapsed': to.collapsibleFieldGroupsCollapsed}"
    >
    <legend class="op-fieldset--legend">
      <button
        title="Show/hide"
        type="button"
        class="op-fieldset--toggle"
        (click)="to.collapsibleFieldGroupsCollapsed = !to.collapsibleFieldGroupsCollapsed"
        >
        {{ to.label }}
      </button>
    </legend>
    <div class="op-fieldset--fields">
      <ng-container #fieldComponent />
    </div>
  </fieldset>
}

@if (!to?.collapsibleFieldGroups) {
  <fieldset
    class="op-fieldset"
    >
    <legend class="op-fieldset--legend">{{ to.label }}</legend>
    <div class="op-fieldset--fields">
      <ng-container #fieldComponent />
    </div>
  </fieldset>
}
